document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.np-hotspot-section');

  sections.forEach(function (section) {
    var wrap = section.querySelector('.np-hotspot-wrap');
    if (!wrap) return;

    var overlay = wrap.querySelector('[data-hotspot-overlay]');
    var markers = wrap.querySelectorAll('[data-hotspot-marker]');
    var cards = wrap.querySelectorAll('[data-hotspot-card]');

    function closeAll() {
      markers.forEach(function (marker) {
        marker.classList.remove('is-active');
        var toggle = marker.querySelector('.np-hotspot-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
      cards.forEach(function (card) {
        card.classList.remove('is-active');
      });
      wrap.classList.remove('has-active-card');
    }

    function openById(id) {
      closeAll();
      var marker = wrap.querySelector('[data-hotspot-marker="' + id + '"]');
      var card = wrap.querySelector('[data-hotspot-card="' + id + '"]');
      if (marker) {
        marker.classList.add('is-active');
        var toggle = marker.querySelector('.np-hotspot-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
      if (card) card.classList.add('is-active');
      wrap.classList.add('has-active-card');
    }

    markers.forEach(function (marker) {
      var id = marker.getAttribute('data-hotspot-marker');
      var card = wrap.querySelector('[data-hotspot-card="' + id + '"]');

      // flip the matching card to the left when the marker sits on the right half
      var leftPercent = parseFloat(marker.style.left);
      if (card && leftPercent > 55) {
        card.classList.add('np-hotspot-card--flip');
      }

      var toggle = marker.querySelector('.np-hotspot-toggle');
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isActive = marker.classList.contains('is-active');
        if (isActive) {
          closeAll();
        } else {
          openById(id);
        }
      });
    });

    cards.forEach(function (card) {
      var closeBtn = card.querySelector('[data-hotspot-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          closeAll();
        });
      }
    });

    if (overlay) {
      overlay.addEventListener('click', closeAll);
    }

    // click outside any marker/card (but still inside this section) closes everything
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) return;
      if (e.target.closest('.np-hotspot') || e.target.closest('.np-hotspot-card')) return;
      closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  });
});
